/* eslint-disable @typescript-eslint/no-unnecessary-condition */
const environment = window.env && process.env.NODE_ENV !== "development" ? window.env : process.env;

const system = {
	publicURL: environment.REACT_APP_PUBLIC_URL_FGTS!,
	apiClientBaseURL: environment.REACT_APP_API_CLIENT_BASE_URL_FGTS!,
	systemConfigurationURL: environment.REACT_APP_SYSTEM_CONFIGURATION_URL_FGTS!,
};

const blob = {
	termsOfConditions: environment.REACT_APP_TERMS_OF_CONDITIONS_FGTS!,
	imagesURL: environment.REACT_APP_IMAGES_URL_FGTS!,
	ccb: environment.REACT_APP_CCB_URL_FGTS!,
	vivoPayAwardTermURL: environment.REACT_APP_VIVO_PAY_AWARD_URL_FGTS!,
};

const ids = {
	signContractTermsId: environment.REACT_APP_SIGN_CONTRACT_TERMS_ID_FGTS!,
	vivoPayAwardTermId: environment.REACT_APP_VIVO_PAY_AWARD_TERMS_ID_FGTS!,
};

const redirects = {
	loginUnique: environment.REACT_APP_LOGIN_UNICO_DOMAIN_FGTS!,
};

const analytics = {
	gtmId: environment.REACT_APP_GTM_FGTS!,
};

const pubSub = {
	apiRMKT: environment.REACT_APP_API_RMKT_URL_FGTS!,
};

const cryptoKey: string = environment.REACT_APP_CRYPTO_KEY_FGTS!;

const envValues: {
	system: typeof system;
	blob: typeof blob;
	ids: typeof ids;
	redirects: typeof redirects;
	analytics: typeof analytics;
	pubSub: typeof pubSub;
	cryptoKey: string;
} = {
	system,
	blob,
	ids,
	redirects,
	analytics,
	pubSub,
	cryptoKey,
};

export const env = Object.freeze(envValues);
